import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Observable } from 'rxjs';
import { checklistMap } from '../checklist-execution-map.component';

@Injectable({
	providedIn: 'root',
})
export class ChecklistExecutionMapService {
	private checklistmapUrl = environment.baseApiUrl + 'checklistmap';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getChecklistMap(year: number, month: number): Observable<checklistMap> {
		return this.http.get<checklistMap>(this.checklistmapUrl, { headers: this.headers, params: { year: year, month: month } });
	}
}
